if (!customElements.get('press-tabs')) {
  class PressTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-press-tab]'));
      this.articles = Array.from(this.querySelectorAll('[data-press-article]'));
      this.emptyState = this.querySelector('.press-tabs__empty');

      if (!this.tabs.length) return;

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(tab.dataset.pressTab));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });

      this.select(this.dataset.activeKey || this.tabs[0].dataset.pressTab, false);

      if (window.Shopify && window.Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const tab = event.target.closest('[data-press-tab]');
          const article = event.target.closest('[data-press-article]');
          const key = tab?.dataset.pressTab || article?.dataset.pressArticle;

          if (key) this.select(key);
        });
      }
    }

    select(key, focusTab = false) {
      const activeTab = this.tabs.find((tab) => tab.dataset.pressTab === key);
      if (!activeTab) return;

      this.dataset.activeKey = key;
      this.tabs.forEach((tab) => {
        const isActive = tab === activeTab;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
      });

      let visibleCount = 0;
      this.articles.forEach((article) => {
        const isVisible = article.dataset.pressArticle === key;
        article.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      if (this.emptyState) this.emptyState.hidden = visibleCount > 0;
      if (focusTab) {
        activeTab.focus();
        activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    onKeydown(event, index) {
      let nextIndex;

      if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === undefined) return;

      event.preventDefault();
      this.select(this.tabs[nextIndex].dataset.pressTab, true);
    }
  }

  customElements.define('press-tabs', PressTabs);
}
